import fileSaver from "file-saver";
import forEach from "lodash/forEach";
import includes from "lodash/includes";
import isArray from "lodash/isArray";
import isDate from "lodash/isDate";
import isFunction from "lodash/isFunction";
import isObject from "lodash/isObject";
import isUndefined from "lodash/isUndefined";
import join from "lodash/join";
import keys from "lodash/keys";
import map from "lodash/map";
export function fileResponseProcessor(response) {
    const { headers } = response;
    if (headers["content-disposition"] && includes(headers["content-disposition"], "attachment")) {
        const defaultFileName = "unknown_blob";
        const fileNameRule = /filename="([\s\S]*)"/i;
        const fileNameSearchResult = headers["content-disposition"].match(fileNameRule);
        const fileName = fileNameSearchResult && fileNameSearchResult.length === 2
            ? fileNameSearchResult[1]
            : defaultFileName;
        let blobConfig;
        const blobType = response.data.type || headers["content-type"];
        if (blobType) {
            blobConfig = { type: blobType };
        }
        const blob = new Blob([response.data], blobConfig);
        fileSaver.saveAs(blob, decodeURIComponent(fileName));
    }
    return null;
}
export function isPromise(value) {
    return value !== null && isObject(value) ? isFunction(value === null || value === void 0 ? void 0 : value.then) : false;
}
export function processResponse(response, responseProcessor) {
    if (isArray(response)) {
        forEach(response, r => processResponse(r, responseProcessor));
        return;
    }
    responseProcessor && responseProcessor(response);
}
export function getPayload(response) {
    if (isArray(response))
        return map(response, getPayload);
    return !isUndefined(response.data.data) ? response.data.data : response.data;
}
export function getStatus(response) {
    if (isArray(response))
        return map(response, getPayload);
    return !isUndefined(response.data.status) ? response.data.status : response.status;
}
export function buildArrayGetRequestParams(name, values) {
    return join(map(values, v => `${name}=${v}`), "&");
}
export function appendData(formData, data, parentKey) {
    if (data && isObject(data) && !isDate(data) && !(data instanceof File)) {
        forEach(keys(data), key => {
            appendData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
    }
    else {
        const value = data == null ? "" : data;
        formData.append(parentKey, value);
    }
}
